/**
 * OpenSearch/Elasticsearch 특수 문자 이스케이핑
 *
 * @description
 * OpenSearch 쿼리 파싱 에러를 방지하기 위해 특수 문자를 이스케이핑합니다.
 * 이스케이핑된 문자는 연산자가 아닌 일반 텍스트로 취급됩니다.
 *
 * @see https://opensearch.org/docs/latest/query-dsl/term/query-string/#reserved-characters
 *
 * @example
 * // URL이 포함된 검색어
 * escapeSearchQuery("http://localhost:5173/tags/Cer")
 * // Returns: "http\\://localhost\\:5173\\/tags\\/Cer"
 *
 * // 연산자가 포함된 검색어
 * escapeSearchQuery("price > 100 && status = active")
 * // Returns: "price \\> 100 \\&\\& status \\= active"
 *
 * @param query - 이스케이핑할 검색 쿼리
 * @returns 이스케이핑된 검색 쿼리
 */
export const escapeSearchQuery = (query: string): string => {
  if (!query) return query;

  // OpenSearch 특수 문자: + - = && || > < ! ( ) { } [ ] ^ " ~ * ? : \ /
  // 공백은 제외 (검색어 구분자로 사용)
  return query.replace(/([+\-=&|><!(){}[\]^"~*?:\\/])/g, '\\$1');
};
